import { render, staticRenderFns } from "./rateRow.vue?vue&type=template&id=254757c2&scoped=true&slot=rates&slot-scope=props&"
import script from "./rateRow.vue?vue&type=script&lang=js&"
export * from "./rateRow.vue?vue&type=script&lang=js&"
import style0 from "./rateRow.vue?vue&type=style&index=0&id=254757c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254757c2",
  null
  
)

component.options.__file = "rateRow.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCheckbox,
  VDialog,
  VDivider,
  VIcon,
  VList,
  VMenu,
  VSpacer,
})
